import React from 'react';
import { DefaultButton, IButtonStyles } from '@fluentui/react';

const styles : IButtonStyles = {
    root: {
        backgroundColor: 'var(--color-primario)',
        color: 'white',
        borderColor: 'var(--color-primario)',
        padding: '0 16px',
        height: 36,
        borderRadius: 8,
        minWidth: 'auto',
    },
    rootHovered: {
        backgroundColor: 'var(--color-primario)',
        color: 'white',
        borderColor: 'var(--color-primario)',
    },
    rootPressed: {
        backgroundColor: 'var(--color-primario)',
        color: 'white',
        borderColor: 'var(--color-primario)',
    },
    label: {
        fontWeight: 500,
    },
};

const stylesSecondary : IButtonStyles = {
    root: {
        backgroundColor: 'white',
        color: 'var(--color-primario)',
        borderColor: 'var(--color-primario)',
        padding: '0 12px',
        height: 32,
        borderRadius: 5,
        minWidth: 'auto',
    },
    rootHovered: {
        backgroundColor: 'var(--color-primario)',
        color: 'white',
        borderColor: 'var(--color-primario)',
    },
    rootPressed: {
        backgroundColor: 'var(--color-primario)',
        color: 'white',
        borderColor: 'var(--color-primario)',
    },
    label: {
        fontWeight: 500,
    },
    icon: {
        color: 'inherit',
    },
};

interface IButtonPrimaryComponentProps {
    text?: string;
    onClick?: (event: any) => void;
    icon?: string;
    disabled?: boolean;
    className?: string;
    secondary?: boolean;
};

const ButtonPrimaryComponent = (props: IButtonPrimaryComponentProps) => {
    return (
        <DefaultButton
            text={props.text}
            onClick={props.onClick}
            iconProps={props.icon ? {
                iconName: props.icon,
            } : {}}
            styles={props.secondary ? stylesSecondary : styles}
            disabled={props.disabled}
            className={props.className} />
    );
};

export default ButtonPrimaryComponent;
